import WalletListPage from '../containers/Wallet/List/WalletList'  
import Header from '../components/Header/Header' 
import SidebarPage from '../components/Sidebar/Sidebar'
import { MainContainer } from '../components/common/Containers'
 
const WalletList = () => {
    return ( 
        <>  
            <SidebarPage />
            <MainContainer>
                <Header /> 
                <main> 
                    <WalletListPage/>  
                </main> 
            </MainContainer>
        </>
    )
}

export default WalletList
